/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFavoriteListFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type FavoriteList, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites/{customerNumber-id}/default
 */
export interface DefaultRequestBuilder extends BaseRequestBuilder<DefaultRequestBuilder> {
    /**
     * Returns the one list the customer has marked as default — the list a client adds to when the shopper has not picked one. A customer has at most one, set either at creation or through PUT /api/favorites/{favoriteListId}/set-default, and promoting a new one clears the flag on the old. Having no default is a normal state, not a failure: a customer with no lists at all, or whose default was deleted, gets a 404 until one is set, since nothing is promoted automatically.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<DefaultRequestBuilderGetQueryParameters> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Returns the one list the customer has marked as default — the list a client adds to when the shopper has not picked one. A customer has at most one, set either at creation or through PUT /api/favorites/{favoriteListId}/set-default, and promoting a new one clears the flag on the old. Having no default is a normal state, not a failure: a customer with no lists at all, or whose default was deleted, gets a 404 until one is set, since nothing is promoted automatically.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<DefaultRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns the one list the customer has marked as default — the list a client adds to when the shopper has not picked one. A customer has at most one, set either at creation or through PUT /api/favorites/{favoriteListId}/set-default, and promoting a new one clears the flag on the old. Having no default is a normal state, not a failure: a customer with no lists at all, or whose default was deleted, gets a 404 until one is set, since nothing is promoted automatically.
 */
export interface DefaultRequestBuilderGetQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const DefaultRequestBuilderUriTemplate = "{+baseurl}/api/favorites/{customerNumber%2Did}/default{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const DefaultRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DefaultRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
